import { render, staticRenderFns } from "./zones.vue?vue&type=template&id=19c6ac19&scoped=true"
import script from "./zones.vue?vue&type=script&lang=js"
export * from "./zones.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19c6ac19",
  null
  
)

export default component.exports